import UserRolesModel from '#model/UserRolesModel'
import { useApiClient } from '#context/ApiContext'
import { useNotifications } from '#context/NotificationContext'
import { useInstanceOf } from 'eilmer-mvvm/react'

export default class UserRolesViewModel {

  constructor(apiClient, notificationsProvider) {
    this.model = new UserRolesModel(apiClient)
    this.notifications = notificationsProvider
    this.entity = new UserRolesModel.UserRole()
    this.editing = false
    this.loadEntities()
  }

  async loadEntities() {
    try {
      this.entities = await this.model.getUserRoles()
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  doEditEntity(entity) {
    this.entity = new UserRolesModel.UserRole(entity)
    this.editing = true
  }

  doCancelEdit() {
    this.editing = false
  }

  async doSaveEntity(entity) {
    try {
      if (entity.isNew()) {
        const result = await this.model.createUserRole(entity)
        this.editing = false
        this.loadEntities()
        return result
      } else {
        const result = await this.model.updateUserRole(entity)
        this.editing = false
        this.loadEntities()
        return result
      }
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  async doDeleteEntity(entity) {
    if (await this.notifications.confirm('Are you sure you\'d like to delete this item?')) {
      try {
        const result = await this.model.deleteUserRole(entity)
        this.loadEntities()
        return result
      } catch (err) {
        console.error(err)
        this.notifications.error(err.message)
      }
    }
  }

  get fields() {
    return [
      { key: 'user_role_id', label: "ID", _style: { width: '6%'}, _classes: 'bg-light text-dark' },
      { key: 'precedence', _style: { width: '15%'} },
      { key: 'name', _style: { width: '25%'} },
      { key: 'description' },
      {
        key: 'actions',
        label: '',
        _style: { width: '90px' },
        filter: false
      }
    ]
  }

}

UserRolesViewModel.useInstance = function() {
  return useInstanceOf(UserRolesViewModel, useApiClient(), useNotifications())
}
